$(() => {
  const $logoBtn = $('.js-logo-btn');

  $logoBtn.on('click', e => {
    e.preventDefault();

    if (!$(window).scrollTop() && window.location.pathname !== '/index.html') {
      window.location.href = '/index.html';
    } else {
      $('html,body').animate({
        scrollTop: 0
      });
    }
  });
});


// WEBPACK FOOTER //
// ./app/assets/js/logo.js